import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';

import {
  CwNavigationDrawer,
  CwNavigationDrawerGroup,
  CwNavigationDrawerItem,
  CwNavigationDrawerSection
} from '@bbraun/cortex-angular';
import { TranslocoDirective } from '@jsverse/transloco';
import { map } from 'rxjs';

import { ROUTES } from '../../../definitions/constants/routes.constants';
import { processTablesNames } from '../../../definitions/enums/process-tables/process-tables-names.enum';
import { ProcessStatuses } from '../../../definitions/enums/replenishment-process/process-status';
import { ProcessType } from '../../../definitions/enums/replenishment-process/process-type.enum';
import { LayoutStoreFacade } from '../../../stores/global-store/layout/layout-store.facade';
import { RouterStoreFacade } from '../../../stores/global-store/router/router-store.facade';
import { UserConfigsStoreFacade } from '../../../stores/global-store/user-configs/user-configs-store.facade';
import { NavigationCountrySwitchComponent } from '../navigation-country-switch/navigation-country-switch.component';

@Component({
  selector: 'app-navigation-internal',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    TranslocoDirective,
    RouterLink,
    RouterLinkActive,
    NavigationCountrySwitchComponent,
    CwNavigationDrawerItem,
    CwNavigationDrawerSection,
    CwNavigationDrawer,
    CwNavigationDrawerGroup,
    NgOptimizedImage
  ],
  templateUrl: './navigation-internal.component.html',
  styleUrls: [ './navigation-internal.component.sass' ],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class NavigationInternalComponent {
  protected readonly userConfigsFacade = inject(UserConfigsStoreFacade);
  protected readonly layoutStoreFacade = inject(LayoutStoreFacade);
  protected readonly routerFacade = inject(RouterStoreFacade);

  protected readonly ProcessType = ProcessType;
  protected readonly ProcessStatuses = ProcessStatuses;
  protected readonly processTablesNames = processTablesNames;

  protected readonly overviewRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.OVERVIEW ];
  protected readonly processesRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.PROCESSES ];
  protected readonly notificationsRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.NOTIFICATIONS ];
  protected readonly historyRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.HISTORY ];
  protected readonly helpRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.HELP ];
  protected readonly settingsRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.SETTINGS ];

  protected readonly isStatusesPanelExpanded$ = this.routerFacade.url$
    .pipe(
      map(url => /\/processes\?.*status=[A-Z_]/.test(url))
    );
}
